module.exports = __webpack_public_path__ + "static/media/2DGACM13.d2abeb91.jpg";